import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const ScrollTop = () => {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  // Clean up after a Bootstrap modal / offcanvas that was still open when the page changed
  // (sidebar links and the browser back button work while a modal is open). Bootstrap adds its
  // backdrop to <body>, so it would otherwise stay as a grey overlay on the next page.
  useEffect(() => {
    document
      .querySelectorAll("body > .modal-backdrop, body > .offcanvas-backdrop")
      .forEach((el) => el.remove());
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("padding-right");
  }, [pathname]);

  // Scroll event → show / hide button
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 200) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    visible && (
      <div className="go_back" onClick={scrollToTop}>
        <i className="bx bx-chevron-up fs-2" />
      </div>
    )
  );
};

export default ScrollTop;
